import { apolloApi } from "@/shared/api";

export async function allPicksLoader(round: string) {
  const response = await apolloApi.getPicks({ round: Number(round) });
  return response;
}

export async function teamPicksLoader({ teamId }: { teamId?: number }) {
  const { pickAssets } = await apolloApi.getPickAssets({ teamId });
  return pickAssets;
}
